export default {
  'user.phonenumber.label': 'Téléphone',
  'user.email.label': 'Email',
  'user.editor.lastname.min.message':
    "Le nom d'utilisateur doit comporter au moins 3 caractères.",
  'user.editor.lastname.required.message':
    "Vous devez indiquer le nom de l'utilisateur",
  'user.error.notfound.label': 'Erreur: utilisateur introuvable!',
};
